import {useCallback, useEffect, useRef, useState} from 'react';

export const useOnUpdate = (callback, dependencies) => {
    const mounted = useRef(false);

    useEffect(
        () => {
            if (mounted.current) callback(dependencies);
            else mounted.current = true;
        },
        dependencies,
    );

    return mounted.current;
};

export const useObject = (factory, dependencies) => {
    const [object, setObject] = useState(factory);

    useOnUpdate(() => setObject(factory), dependencies);

    return object;
};

export const useTimer = (initial) => {
    const timer = useRef(initial);

    const abortTimer = useCallback(
        () => {
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = initial;
            }
        },
        [timer],
    );

    const startTimer = useCallback(
        (callback, delay) => {
            abortTimer();
            timer.current = setTimeout(callback, delay);
        },
        [timer],
    );

    return [startTimer, abortTimer];
};

export const useClassName = (node, className, condition = true) => useEffect(
    () => {
        if (node && condition) {
            node.classList.add(className);

            return () => {
                node.classList.remove(className);
            };
        }
    },
    [condition, node, className],
);
